import { yupResolver } from '@hookform/resolvers/yup';
import React, { memo, useEffect, useState, useCallback } from "react";
import { Button, Form, Modal, Row, Col } from "react-bootstrap";
import { useForm } from 'react-hook-form';
import { v4 as uuidv4 } from 'uuid';
import Loader from "react-js-loader";
import { ToastContainer, toast } from 'react-toastify';
import * as Yup from 'yup';
import { getEndpointUrl, CAR_MODEL_TYPES } from '../../Utils/Common';

const CreateItem = ({ onCallback, show, close }) => {

    const [isLoading, setLoading] = useState(false);

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const [users, setUsers] = useState([]);
    const [brands, setBrands] = useState([]);
    const [types, setTypes] = useState([]);

    const fetchData = useCallback(async () => {
        setLoading(true);
        fetch(getEndpointUrl() + `/users?page=0&per_page=200`, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok')
                setUsers(json.results.data);

            setLoading(false);
        });
    }, []);

    const fetchBrands = useCallback(async () => {
        fetch(getEndpointUrl() + `/v2/car_brand?page=0&per_page=200`, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok')
                setBrands(json.results.data);
        });
    }, []);

    const fetchTypes = useCallback(async (brandId) => {
        let url = `/v2/car_type?page=0&per_page=200`;
        if (brandId) {
            url += `&brand_id=${brandId}`;
        }
        fetch(getEndpointUrl() + url, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok')
                setTypes(json.results.data);
        });
    }, []);

    useEffect(() => {
        fetchData();
        fetchBrands();
        fetchTypes();
    }, [show]);

    const validationSchema = Yup.object().shape({
        contactName: Yup.string().required('Field harus diisi'),
        contactPhone: Yup.string().required('Field harus diisi'),
        brandName: Yup.string().required('Field harus diisi'),
        type: Yup.string().required('Field harus diisi'),
        model: Yup.string().required('Field harus diisi'),
        builtYear: Yup.string().required('Field harus diisi'),
        policeNumber: Yup.string().nullable(),

        color: Yup.string().nullable(),
        odometer: Yup.string().nullable(),
        transmission: Yup.string().nullable(),
        serviceRecords: Yup.string().nullable(),
        tax: Yup.string().nullable(),
        manualBook: Yup.string().nullable(),

        location: Yup.string().required('Field harus diisi'),
        user_id: Yup.string().nullable()
    });

    const {
        register,
        handleSubmit,
        reset,
        watch,
        formState: { errors }
    } = useForm({
        mode: "onChange",
        resolver: yupResolver(validationSchema)
    });

    const watchedBrandName = watch("brandName");

    useEffect(() => {
        if (watchedBrandName) {
            const selectedBrand = brands.find(b => b.companyName === watchedBrandName);
            if (selectedBrand) {
                fetchTypes(selectedBrand.id);
            }
        }
    }, [watchedBrandName, brands]);

    const onSubmit = data => {
        setLoading(true);
        const id = uuidv4();
        const newTask = { id, ...data }

        setTimeout(() => {
            setLoading(false);
            onCallback(newTask);
            reset();
            close();
        }, 300);
    };
    return (
        <>
            <ToastContainer position="top-end" className="p-3"></ToastContainer>
            <Modal show={show} size="lg" onHide={close} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>{isLoading ? "Loading..." : "Input item penawaran"}</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleSubmit(onSubmit)} key={'update-item'}>
                    {isLoading ?
                        <Modal.Body>
                            <div className="d-flex justify-content-center mt-5 mb-5">
                                <Loader type="bubble-scale" bgColor={"#42A5F5"} size={100} />
                            </div>
                        </Modal.Body>
                        :
                        <>
                            <Modal.Body>
                                <Row>
                                    <Col md={6} sm={12}>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Merk</Form.Label>
                                            <Form.Select {...register("brandName")} isInvalid={errors.brandName ? true : false}>
                                                <option value="">- Pilih Merek -</option>
                                                {brands.map((brand, key) =>
                                                    <option key={brand.id} value={brand.companyName}>{brand.companyName}</option>
                                                )}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12}>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Tipe</Form.Label>
                                            <Form.Select {...register("type")} isInvalid={errors.type ? true : false}>
                                                <option value="">- Pilih Tipe -</option>
                                                {types.map((type, key) =>
                                                    <option key={type.id} value={type.typeName}>{type.typeName}</option>
                                                )}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12}>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Model</Form.Label>
                                            <Form.Select {...register("model")} isInvalid={errors.model ? true : false}>
                                                <option value="">- Pilih Model -</option>
                                                {CAR_MODEL_TYPES.map((model, key) =>
                                                    <option key={key} value={model}>{model}</option>
                                                )}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12}>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Nama Kontak</Form.Label>
                                            <Form.Control type="text" {...register("contactName")} isInvalid={errors.contactName ? true : false} autoComplete="off" />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12}>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Nomor Kontak</Form.Label>
                                            <Form.Control type="text" {...register("contactPhone")} isInvalid={errors.contactPhone ? true : false} autoComplete="off" />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12}>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Nomor Polisi</Form.Label>
                                            <Form.Control type="text" {...register("policeNumber")} isInvalid={errors.policeNumber ? true : false} autoComplete="off" />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12}>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Lokasi Unit</Form.Label>
                                            <Form.Control type="text" {...register("location")} isInvalid={errors.location ? true : false} autoComplete="off" />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12}>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Warna</Form.Label>
                                            <Form.Control type="text" {...register("color")} isInvalid={errors.color ? true : false} autoComplete="off" />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12}>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Tahun</Form.Label>
                                            <Form.Control type="number" {...register("builtYear")} isInvalid={errors.builtYear ? true : false} autoComplete="off" />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12}>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Odometer</Form.Label>
                                            <Form.Control type="number" {...register("odometer")} isInvalid={errors.odometer ? true : false} autoComplete="off" />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12}>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Transmisi</Form.Label>
                                            <Form.Select {...register("transmission")} isInvalid={errors.transmission ? true : false}>
                                                <option value="">- Pilih -</option>
                                                <option value={'Manual'}>Manual</option>
                                                <option value={'Otomatis'}>Otomatis</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12}>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Pajak</Form.Label>
                                            <Form.Control type="text" {...register("tax")} isInvalid={errors.tax ? true : false} autoComplete="off" />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12}>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Buku Servis</Form.Label>
                                            <Form.Control type="text" {...register("serviceRecords")} isInvalid={errors.serviceRecords ? true : false} autoComplete="off" />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12}>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Buku Manual</Form.Label>
                                            <Form.Control type="text" {...register("manualBook")} isInvalid={errors.manualBook ? true : false} autoComplete="off" />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12}>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Petugas Inspeksi</Form.Label>
                                            <Form.Select {...register("user_id")} isInvalid={errors.user_id ? true : false}>
                                                <option>- Pilih Petugas -</option>
                                                {users.map((user, key) =>
                                                    <option value={user.id}>{user.name}</option>
                                                )}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={close}> Batal </Button>
                                <Button variant="success" type="submit">Input Item Penawaran</Button>
                            </Modal.Footer>
                        </>
                    }
                </Form>
            </Modal>
        </>
    );
}

export default memo(CreateItem);
